import React, { useEffect, useState, useRef } from 'react';
import { loadConfig } from '../../services/config';
import ButtonComponent from "../../components/button";

const AirwallexPayment = ({ currency, clientSecret, intentId, onSuccess, onError }) => {
  const [isReady, setIsReady] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);
  const dropInContainerRef = useRef(null);

	const sc_theme = localStorage.getItem("sc_theme") || "light";

  useEffect(() => {
    // Check if script is already loaded
    if (window.Airwallex) {
      initializeAirwallex();
      return;
    }
  }, []);

  const initializeAirwallex = async () => {
    try {
			const appConfig = await loadConfig();
			let env_mode = "prod";
			if(appConfig.env === 'staging' || appConfig.env === 'sandbox'){
				env_mode = "demo";
			}

      window.Airwallex.init({
        env: env_mode,
        origin: window.location.origin,
      });
      setIsReady(true);
    } catch (err) {
      console.error('Failed to initialize Airwallex', err);
      setError('Failed to initialize payment gateway');
    }
  };

  useEffect(() => {
    if (isReady && clientSecret && intentId && dropInContainerRef.current) {
      // Create the drop-in element

			const lightStyleProps = {
				mode: 'light',
			};

			const darkStyleProps = {
				mode: 'dark',
				variables: {
					colorBrand: '#962bf8',
					colorBackground: '#151516',
					colorText: '#ffffff',
				}
			};

      const dropIn = window.Airwallex.createElement('dropIn', {
        client_secret: clientSecret,
        intent_id: intentId,
				currency: currency,
				appearance: sc_theme === 'dark' ? darkStyleProps : lightStyleProps
      });

      // Mount the element
      dropIn.mount(dropInContainerRef.current);

			dropIn.on('success', (response) => {
				console.log(response);
				onSuccess(response);
			});

			dropIn.on('error', (error) => {
				console.log(error);
				onError(error);
			});

      return () => {
        dropIn.unmount();
      };
    }
  }, [isReady, clientSecret, intentId]);

  if (!isReady) {
    return <p className="note text-center">Fetching payment methods! Please wait...</p>;
  }

  if (!clientSecret || !intentId) {
    return <p className="note text-center">Fetching payment methods! Please wait...</p>;
  }

  return (
    <div>
      <div ref={dropInContainerRef} id="airwallex-dropin-container"></div>
      
      {error && <div className="error-message mt-3">{error}</div>}
    </div>
  );
};

export default AirwallexPayment;